import { Colour } from 'components/variables'
import { PatternType } from '../data/models/page'

const randomColours = [
  Colour.blue,
  Colour.green,
  Colour.mint,
  Colour.orange,
  Colour.pink,
  Colour.purple,
  Colour.steelBlue,
  Colour.turquoise,
  Colour.yellow,
]

export const getRandomColor: () => Colour = () => {
  return randomColours[Math.floor(Math.random() * randomColours.length)]
}

export function getRandomPatternType(): PatternType {
  const types = Object.values(PatternType)
  return types[Math.floor(Math.random() * types.length)]
}
